import { useTrackEnteredFullScreen, useTrackExitedFullScreen } from '@air/analytics';
import { RefObject, useCallback, useEffect } from 'react';

import { useFullscreenContext } from '~/components/AssetModal/shared/context/FullscreenContext';
import { useFullScreen } from '~/hooks/useFullScreen';

export const useTogglePDFFullscreen = (containerRef: RefObject<HTMLElement> | null) => {
  const [isFullScreen, toggleFullScreen] = useFullScreen(containerRef);

  const { trackEnteredFullScreen } = useTrackEnteredFullScreen();
  const { trackExitedFullScreen } = useTrackExitedFullScreen();
  const { setIsFullscreen } = useFullscreenContext();

  const onToggleFullscreen = useCallback(() => {
    toggleFullScreen();
    if (isFullScreen) {
      trackExitedFullScreen({ location: 'pdf' });
    } else {
      trackEnteredFullScreen({ location: 'pdf' });
    }
  }, [isFullScreen, toggleFullScreen, trackEnteredFullScreen, trackExitedFullScreen]);

  useEffect(() => {
    setIsFullscreen(isFullScreen);
    return () => {
      setIsFullscreen(false);
    };
  }, [isFullScreen, setIsFullscreen]);

  return {
    isFullScreen,
    onToggleFullscreen,
  };
};
